import { createUseStyles } from 'react-jss';
import colors from "../../utils/colors";



var styles = {
  sidebarTitle: {
    fontSize: '2.4rem',
    fontWeight: 700,
    paddingBottom: '2.8rem',
    lineHeight: '3.2rem',
    borderBottom: "0.1rem solid ".concat(colors.neutral[300]),
    marginBottom: '4.2rem',
    textAlign: 'center'
  },
  savingStatusWrapper: {
    color: colors.green[600],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    textTransform: 'capitalize'
  },
  savingStatus: {
    fontSize: '1.6rem',
    paddingLeft: '0.4rem',
    lineHeight: '2.4rem'
  },
  footerButtons: function footerButtons(type) {return {
      margin: type === 'template' ? 0 : '5rem 0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '3rem',
      flexWrap: 'wrap'
    };},
  collapsedProductLineButton: {
    fontWeight: 700,
    paddingLeft: 0
  },
  collapsedSectionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginBottom: '2rem'
  },
  infoMessage: {
    fontSize: '1.4rem',
    color: colors.green[600]
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map